import { render, staticRenderFns } from "./tiya.vue?vue&type=template&id=74b6099a&"
import script from "./tiya.vue?vue&type=script&lang=js&"
export * from "./tiya.vue?vue&type=script&lang=js&"
import style0 from "./tiya.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tiya.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports